import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.css";
import "./index.css";
import App from "./App";
import { store } from "./app/store";

import { Provider } from "react-redux";

import { Amplify } from "aws-amplify";
const config = require("./aws-exports").default;
Amplify.configure(config);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <Provider store={store}>
    {/* @ts-ignore */}
    <App />
  </Provider>
);
